<template>
  <div v-if="visible" class="modal-overlay" @click="handleClose">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h2 class="modal-title">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z" />
          </svg>
          <span>{{
            activeTab === 'message' ? '消息模板设置' : '邮件模板设置'
          }}</span>
        </h2>
        <button class="close-btn" @click="handleClose">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <!-- 统一使用默认设置 -->
        <div class="settings-section">
          <h3 class="section-title">发送设置</h3>
          <div class="setting-item">
            <label class="setting-label">未互动时间</label>
            <div class="setting-control">
              <input v-model.number="settings.unSendUserTime" type="number" min="1" max="24" class="setting-input"
                placeholder="请输入未互动时间" />
              <span class="setting-unit">小时</span>
            </div>
          </div>
          <div class="setting-item">
            <label class="setting-label">持续时间</label>
            <div class="setting-control">
              <input v-model.number="settings.sendInterval" type="number" min="1" max="24" class="setting-input"
                placeholder="请输入持续时间" />
              <span class="setting-unit">小时</span>
            </div>
          </div>

          <div class="setting-item">
            <label class="setting-label">每次发送给多少用户</label>
            <div class="setting-control">
              <input v-model.number="settings.dailyLimit" type="number" min="1" max="1000" class="setting-input"
                placeholder="请输入每次发送给多少用户" />
              <span class="setting-unit">人</span>
            </div>
          </div>
        </div>
        <p style="color: red">
          *持续时间>未互动时间时，同一客户可能会收到多次相同的消息
        </p>
      </div>

      <div class="modal-actions">
        <button class="btn btn-secondary" @click="handleClose">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" @click="handleSave" :disabled="loading">
          <svg v-if="!loading" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
          </svg>
          <svg v-if="loading" class="loading-spinner" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z">
              <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 12 12"
                to="360 12 12" repeatCount="indefinite" />
            </path>
          </svg>
          <span>{{ loading ? '保存中...' : '保存设置' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  updateMassTask,
  addMassTask,
  batchAddMassTask,
  pdMassMessageMassTask,
} from '@/api/talkytimes/masSending';

export default {
  name: 'SettingsModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    activeTab: {
      type: String,
      default: 'message',
    },
    selectedUser: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false, // 保存按钮loading状态
      settings: {
        sendInterval: 0, // 持续时间（小时）
        unSendUserTime: 0, // 未互动时间（小时）
        dailyLimit: 0, // 每次发送用户数
        autoSend: false, // 自动发送
        contentReview: true, // 内容审核
        sensitiveFilter: true, // 敏感词过滤
        successNotification: true, // 发送成功通知
        failureNotification: true, // 发送失败通知
      },
    };
  },
  mounted() {
    // 组件挂载时初始化设置
    if (this.visible) {
      this.initializeSettings();
    }
  },
  watch: {
    // 监听 visible 属性变化，当模态框打开时初始化设置
    visible(newVal) {
      if (newVal) {
        this.initializeSettings();
      }
    },
  },
  methods: {
    // 初始化设置值
    initializeSettings() {
      if (this.selectedUser && this.selectedUser.userMassSetting) {
        const userSetting = this.selectedUser.userMassSetting;

        if (this.activeTab === 'message') {
          // 消息设置
          this.settings.sendInterval = userSetting.messageIntervalTime
            ? Math.floor(userSetting.messageIntervalTime / 60)
            : 0; // 转换为小时
          this.settings.unSendUserTime = userSetting.messageUnSendUserTime || 0;
          this.settings.dailyLimit = userSetting.messageSendUserNum || 0;
        } else {
          // 邮件设置
          this.settings.sendInterval = userSetting.mailIntervalTime
            ? Math.floor(userSetting.mailIntervalTime / 60)
            : 0; // 转换为小时
          this.settings.unSendUserTime = userSetting.mailUnSendUserTime || 0;
          this.settings.dailyLimit = userSetting.mailSendUserNum || 0;
        }

        // 确保所有值都是数字类型
        this.settings.sendInterval = parseInt(this.settings.sendInterval) || 0;
        this.settings.unSendUserTime =
          parseInt(this.settings.unSendUserTime) || 0;
        this.settings.dailyLimit = parseInt(this.settings.dailyLimit) || 0;

        console.log('初始化设置值:', {
          activeTab: this.activeTab,
          settings: this.settings,
          userSetting: userSetting,
        });
      } else {
        // 如果没有用户设置，重置为默认值
        this.settings.sendInterval = 0;
        this.settings.unSendUserTime = 0;
        this.settings.dailyLimit = 0;
        console.log('重置为默认设置值:', this.settings);
      }
    },

    handleClose() {
      this.$emit('close');
    },
    async handleSave() {
      if (this.loading) return; // 防止重复提交

      this.loading = true; // 开始loading
      try {
        console.log('activeTab:::::::', this.activeTab);
        const jobType = this.activeTab === 'message' ? '1' : '0'; // 1:消息 0:邮件
        console.log('jobType:', jobType, 'type:', typeof jobType);

        // 检查用户是否有相应的模板
        const hasTemplate =
          this.activeTab === 'message'
            ? this.selectedUser.userMassSetting?.message
            : this.selectedUser.userMassSetting?.mail;
        const jobId =
          this.activeTab === 'message'
            ? this.selectedUser.userMassSetting?.messageJobId
            : this.selectedUser.userMassSetting?.mailJobId;

        console.log('当前模板状态:', {
          activeTab: this.activeTab,
          message: this.selectedUser.userMassSetting?.message,
          mail: this.selectedUser.userMassSetting?.mail,
          hasTemplate: hasTemplate,
        });

        // 检查当前标签页对应的模板状态
        const currentTemplateStatus =
          this.activeTab === 'message'
            ? this.selectedUser.userMassSetting?.message
            : this.selectedUser.userMassSetting?.mail;

        console.log('当前模板状态:', {
          activeTab: this.activeTab,
          message: this.selectedUser.userMassSetting?.message,
          mail: this.selectedUser.userMassSetting?.mail,
          currentTemplateStatus: currentTemplateStatus,
          jobId: jobId,
        });

        // 统一使用 pdMassMessageMassTask 接口
        console.log('执行模版设置流程');

        // 处理空值，确保数据有效性
        const sendUserNum = this.settings.dailyLimit
          ? parseInt(this.settings.dailyLimit)
          : 0;
        const intervalTime = this.settings.sendInterval
          ? parseInt(this.settings.sendInterval) * 60
          : 0; // 转换为分钟
        const unSendUserTime = this.settings.unSendUserTime
          ? parseInt(this.settings.unSendUserTime)
          : 0;

        const massTaskData = {
          idUsers: [this.selectedUser.id],
          jobType: jobType, // 0:邮件 1:消息
          sendUserNum: sendUserNum,
          intervalTime: intervalTime,
          unSendUserTime: unSendUserTime,
        };

        console.log('模版设置数据:', massTaskData);
        const response = await pdMassMessageMassTask(massTaskData);
        console.log('模版设置成功:', response);
        this.$emit('success', '模版设置成功');

        this.$emit('close');
      } catch (error) {
        console.error('保存设置失败:', error);
        this.$emit('error', '保存设置失败');
      } finally {
        this.loading = false; // 结束loading
      }
    },
  },
};
</script>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.modal-content {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 28px 32px;
  border-bottom: 1px solid rgba(229, 231, 235, 0.8);
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 20px 20px 0 0;
}

.modal-title {
  font-size: 24px;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.modal-title svg {
  width: 28px;
  height: 28px;
  color: #8b5cf6;
}

.close-btn {
  background: rgba(243, 244, 246, 0.8);
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #6b7280;
  padding: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.close-btn:hover {
  color: #1f2937;
  background: rgba(239, 68, 68, 0.1);
  transform: rotate(90deg);
}

.modal-body {
  padding: 32px;
}

.settings-section {
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(229, 231, 235, 0.8);
}

.setting-item {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 16px;

  &:last-child {
    margin-bottom: 0;
  }
}

.setting-label {
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  min-width: 140px;
  flex-shrink: 0;
}

.setting-control {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.setting-input {
  flex: 1;
  max-width: 200px;
  padding: 12px 16px;
  border: 1px solid rgba(229, 231, 235, 0.8);
  border-radius: 8px;
  font-size: 14px;
  background: white;
  color: #1f2937;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #8b5cf6;
    box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
}

.setting-unit {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
  white-space: nowrap;
}

.setting-hint {
  font-size: 13px;
  color: #6b7280;
  margin: 8px 0 0 156px;
  /* 156px = 140px (label width) + 16px (gap) */
  line-height: 1.5;
}

/* 开关样式 */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.switch-input {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e5e7eb;
  transition: 0.3s;
  border-radius: 24px;

  &:before {
    position: absolute;
    content: '';
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
}

.switch-input:checked+.switch-slider {
  background-color: #8b5cf6;
}

.switch-input:checked+.switch-slider:before {
  transform: translateX(26px);
}

.modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  padding: 20px 32px;
  border-top: 1px solid rgba(229, 231, 235, 0.8);
  background: rgba(249, 250, 251, 0.8);
  border-radius: 0 0 20px 20px;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent);
  transition: left 0.5s;
}

.btn:hover::before {
  left: 100%;
}

.btn-primary {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.3);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(139, 92, 246, 0.4);
}

.btn-primary:disabled {
  background: linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%);
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.2);
  opacity: 0.8;
}

.btn-primary:disabled:hover {
  transform: none;
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.2);
}

.loading-spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.9);
  color: #8b5cf6;
  border: 2px solid rgba(139, 92, 246, 0.3);
  backdrop-filter: blur(10px);
}

.btn-secondary:hover {
  background: rgba(139, 92, 246, 0.1);
  border-color: #8b5cf6;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(139, 92, 246, 0.2);
}

/* 滚动条样式 */
.modal-content::-webkit-scrollbar {
  width: 8px;
}

.modal-content::-webkit-scrollbar-track {
  background: rgba(241, 245, 249, 0.8);
  border-radius: 4px;
}

.modal-content::-webkit-scrollbar-thumb {
  background: rgba(139, 92, 246, 0.3);
  border-radius: 4px;
  transition: background 0.3s ease;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background: rgba(139, 92, 246, 0.5);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    margin: 20px;
  }

  .modal-body {
    padding: 24px;
  }

  .modal-header {
    padding: 20px 24px;
  }

  .modal-title {
    font-size: 20px;
  }

  .modal-actions {
    flex-direction: column;
    gap: 12px;
    padding: 16px 24px;
  }

  .setting-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .setting-label {
    min-width: auto;
    width: 100%;
  }

  .setting-control {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }

  .setting-input,
  .setting-select {
    max-width: 100%;
  }

  .setting-hint {
    margin: 8px 0 0 0;
  }
}
</style>
